import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// COMPONENTS
import Hakkimizda from "./components/Hakkimizda";
import Hizmetler from "./components/Hizmetler";
import Projeler from "./components/Projeler";
import Iletisim from "./components/Iletisim";

// PAGES
import Home from "./pages/Home";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import Musteriler from "./pages/Musteriler";
import MusteriDetay from "./pages/MusteriDetay";
import YeniCari from "./pages/YeniCari";

import Odemeler from "./pages/Odemeler";
import YeniOdeme from "./pages/YeniOdeme";

import Tedarikciler from "./pages/Tedarikciler";
import TedarikciGiderDetay from "./pages/TedarikciGiderDetay";
import TedarikciDetay from "./pages/TedarikciDetay"; 

import PatronDashboard from "./pages/PatronDashboard";
import GelecekAylar from "./pages/GelecekAylar";
import PatronMusteriler from "./pages/PatronMusteriler";
import PatronRaporlama from "./pages/PatronRaporlama";

// --- YENİ: LOG SAYFASINI İÇERİ ALIYORUZ ---
import LogKayitlari from "./pages/LogKayitlari"; 

function App() {
  return (
    <> 
      <Navbar />

      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<Hakkimizda />} />
        <Route path="/hizmetler" element={<Hizmetler />} />
        <Route path="/projeler" element={<Projeler />} />
        <Route path="/iletisim" element={<Iletisim />} />

        {/* ADMIN */}
        <Route path="/login" element={<Login />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />

        {/* CARİLER */}
        <Route path="/cariler" element={<Musteriler />} />
        <Route path="/cariler/:id" element={<MusteriDetay />} />
        <Route path="/yeni-cari" element={<YeniCari />} />

        {/* ÖDEMELER */}
        <Route path="/odemeler" element={<Odemeler />} />
        <Route path="/yeni-odeme" element={<YeniOdeme />} />

        {/* TEDARİKÇİLER */}
        <Route path="/tedarikciler" element={<Tedarikciler />} />
        <Route path="/tedarikciler/:id" element={<TedarikciDetay />} />
        <Route path="/giderler/:id" element={<TedarikciGiderDetay />} />

        {/* PATRON */}
        <Route path="/patron/dashboard" element={<PatronDashboard />} />
        <Route path="/patron/gelecek-aylar" element={<GelecekAylar />} />
        <Route path="/patron/musteriler" element={<PatronMusteriler />} />
        <Route path="/patron/raporlama" element={<PatronRaporlama />} />

        {/* --- YENİ: GİZLİ TEKNİK ODA --- */}
        <Route path="/teknik/logs" element={<LogKayitlari />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;